import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AboutPage from "../views/AboutPage.vue";
import ApplicationPage from "../views/ApplicationPage.vue";
// eslint-disable-next-line
import NpApplicationPage from "../views/NpApplicationPage.vue";
import HelpPage from "../views/HelpPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import MyAccountPage from "../views/MyAccountPage.vue";
import SignInPage from "../views/SignInPage.vue";
import ResetPasswordPage from "../views/ResetPasswordPage.vue";
import RequestPasswordResetPage from "../views/RequestPasswordResetPage.vue";

import store, { types } from "../store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "about",
    component: AboutPage,
  },
  {
    path: "/application/:id",
    name: "application",
    component: ApplicationPage,
  },
  {
    path: "/help",
    name: "help",
    component: HelpPage,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterPage,
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: SignInPage,
  },
  {
    path: "/sign-out",
    name: "sign-out",
    beforeEnter: () => {
      store.dispatch(types.LOGOUT);
      return false;
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPasswordPage,
  },
  {
    path: "/request-password-reset",
    name: "request-password-reset",
    component: RequestPasswordResetPage,
  },
  {
    path: "/my-account",
    name: "my-account",
    component: MyAccountPage,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
